const notification = () => {
  return {
    show: false,
    text: null,
    timeout: 4000,
    color: 'info' // ['info', 'error', 'success', 'warning']
  }
}

function getStoredLanguage () {
  const supported = ['pt_BR', 'en_US', 'es_ES']
  try {
    const stored = window.localStorage.getItem('language')
    return supported.indexOf(stored) !== -1 ? stored : 'pt_BR'
  } catch (err) {
    return 'pt_BR'
  }
}

function getStoredDashboardViewModeMode () {
  try {
    const stored = window.localStorage.getItem('dashboardViewMode')
    return stored === 'list' || stored === 'table' ? stored : 'table'
  } catch (err) {
    return 'table'
  }
}

export default {
  state: {
    dashboardViewMode: {
      mode: getStoredDashboardViewModeMode(), // or 'list'
      show: false
    },
    connected: false,
    loading: false,
    error: null,
    notification,
    language: getStoredLanguage(),
    snackbar: {
      show: false,
      text: null,
      timeout: 4000,
      color: 'info'
    }
  },
  getters: {
    dashboardViewMode (state) {
      return state.dashboardViewMode
    },
    connected (state) {
      return state.connected
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    notification (state) {
      return state.notification
    },
    language (state) {
      return state.language
    },
    snackbar (state) {
      return state.snackbar
    }
  },
  // synchronuos
  mutations: {
    setDashboardViewMode (state, payload) {
      state.dashboardViewMode = payload
    },
    setConnection (state, paylod) {
      state.connected = paylod
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setNotification (state, { text = null, timeout = 4000, type = 'info' }) {
      state.notification = {
        show: true,
        text,
        timeout,
        color: type // ['success', 'info', 'error']
      }
    },
    clearNotification (state) {
      state.notification = notification
    },
    clearError (state) {
      state.error = null
    },
    setLanguage (state, payload) {
      state.language = payload
    },
    setSnackbar (state, payload) {
      state.snackbar = payload
    },
    closeSnackbar (state) {
      state.snackbar.show = false
    }
  },
  // asynchronous
  actions: {
    setDashboardViewMode ({ commit }, payload) {
      let _payload = {
        mode: getStoredDashboardViewModeMode(),
        show: true
      }

      if ('mode' in payload) {
        if (payload.mode === 'table' || payload.mode === 'list') {
          _payload.mode = payload.mode
        }
      }

      if ('show' in payload) {
        _payload.show = payload.show
      }

      try {
        window.localStorage.setItem('dashboardViewMode', _payload.mode)
      } catch (err) {
        // ignore storage errors (e.g. private mode / quota)
      }

      commit('setDashboardViewMode', _payload)
    },
    setConnection ({ commit }, payload) {
      commit('setConnection', payload)
    },
    clearError ({ commit }) {
      commit('clearError')
    },
    setLanguage ({ commit }, payload) {
      commit('setLanguage', payload)
    },
    // Need remove it
    setSnackbar ({ commit }, payload) {
      const _payload = {
        show: payload.show || true,
        text: payload.text || '',
        timeout: payload.timeout || 4000,
        color: payload.color || '#754189'
      }

      commit('setSnackbar', _payload)
    },
    setNotification ({ commit }, payload) {
      commit('setNotification', payload)
    },
    clearNotification ({ commit }) {
      commit('clearNotification')
    },
    closeSnackbar ({ commit }) {
      commit('closeSnackbar')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/index.js